/** CSS contract: css-library/components/02-containers/pill.css. */
import type { ComponentProps } from 'react';
import { cx } from '../lib/cx';

export type PillProps = ComponentProps<'div'>;

export function Pill({ className, ...props }: PillProps) {
  return <div className={cx('pill', className)} {...props} />;
}
